import api from './api';

const handleApiError = (error, operation) => {
  console.error(`Erro na operação ${operation}:`, error);
  if (error.response) {
    console.error('Resposta do servidor:', error.response.data);
    console.error('Status do erro:', error.response.status);
    throw new Error(
      error.response.data.mensagem ||
        `Erro na resposta do servidor durante ${operation}`
    );
  } else if (error.request) {
    console.error('Sem resposta do servidor');
    throw new Error(
      `Não foi possível conectar ao servidor durante ${operation}. Tente novamente mais tarde.`
    );
  } else {
    console.error('Erro de configuração da requisição:', error.message);
    throw new Error(
      `Ocorreu um erro ao processar sua requisição durante ${operation}.`
    );
  }
};

export const login = async (identificador, senha) => {
  try {
    console.log('Tentando login para:', identificador);
    const response = await api.post('/auth/login', { identificador, senha });
    console.log('Resposta do login:', response.data);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      console.log('Token armazenado no localStorage:', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      console.log(
        'Usuário armazenado no localStorage:',
        response.data.user
      );
    } else {
      console.error('Token não recebido do servidor');
      throw new Error('Token não recebido do servidor');
    }
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return' - apenas chama handleApiError
    handleApiError(error, 'login');
  }
};

export const register = async (userData) => {
  try {
    console.log('Tentando registrar usuário:', userData);

    // 1. Se não tiver email, força metodoCadastro como 'username'
    if (!userData.email) {
      userData.metodoCadastro = 'username';
    }

    // 2. Garantir que o username use ponto em vez de underscore
    if (userData.username) {
      userData.username = userData.username.replace(/_/g, '.');
    }

    // 3. Enviar dados de registro para a API
    const response = await api.post('/auth/registro', userData);
    console.log('Resposta do registro:', response.data);

    // 4. Armazenar token e informações do usuário no localStorage, se presentes
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      console.log(
        'Token armazenado no localStorage após registro:',
        response.data.token
      );
      localStorage.setItem('user', JSON.stringify(response.data.user));
      console.log(
        'Usuário armazenado no localStorage após registro:',
        response.data.user
      );
    } else {
      console.error('Token não recebido do servidor após registro');
    }

    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'registro');
  }
};

export const logout = async () => {
  try {
    await api.post('/auth/logout');
    console.log('Realizando logout');
  } catch (error) {
    console.error('Erro ao realizar logout:', error);
  } finally {
    // MUDANÇA: Limpar ambas as chaves para garantir limpeza completa
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('user'); // Remove a chave antiga também
    console.log('Token e dados do usuário removidos do localStorage');
  }
};

export const verifyEmail = async (token) => {
  try {
    console.log('Verificando email com token:', token);
    const response = await api.get(`/auth/verificar-email/${token}`);
    console.log('Resposta da verificação de email:', response.data);
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'verificação de email');
  }
};

export const resendVerification = async (email) => {
  try {
    console.log('Reenviando verificação para:', email);
    const response = await api.post('/auth/reenviar-verificacao', { email });
    console.log('Resposta do reenvio:', response.data);
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'reenvio de verificação');
  }
};

export const requestPasswordReset = async (identificador) => {
  try {
    console.log('Solicitando reset de senha para:', identificador);
    const response = await api.post('/auth/solicitar-reset-senha', { identificador });
    console.log('Resposta da solicitação:', response.data);
    return response.data;
  } catch (error) {
    // ✅ NOTA: Esta função mantém throw error; - deixando como estava
    throw error;
    // Comentado: return handleApiError(error, 'solicitação de reset de senha');
  }
};

// Adicionar nova função para adicionar email
export const adicionarEmailRecuperacao = async (identificador, email) => {
  try {
    console.log('Adicionando email para recuperação:', { identificador, email });
    const response = await api.post('/auth/adicionar-email-recuperacao', {
      identificador,
      email
    });
    console.log('Resposta da adição de email:', response.data);
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'adição de email para recuperação');
  }
};

export const resetPassword = async (token, novaSenha) => {
  try {
    console.log('Resetando senha com token:', token);
    const response = await api.post(`/auth/reset-senha/${token}`, {
      novaSenha,
    });
    console.log('Resposta do reset de senha:', response.data);
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'reset de senha');
  }
};

export const changePassword = async (senhaAtual, novaSenha) => {
  try {
    console.log('Alterando senha do usuário');
    const response = await api.post('/auth/alterar-senha', {
      senhaAtual,
      novaSenha,
    });
    console.log('Resposta da alteração de senha:', response.data);
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'alteração de senha');
  }
};

// ==================================================
//               FUNÇÕES DE OBTENÇÃO
// ==================================================

// src/services/authService.js - Função getCurrentUser corrigida
export const getCurrentUser = () => {
  // Tenta buscar com ambas as chaves para compatibilidade
  const userStr = localStorage.getItem('usuario') || localStorage.getItem('user');
  if (userStr) {
    console.log('Usuário atual recuperado do localStorage');
    try {
      return JSON.parse(userStr);
    } catch (error) {
      console.error('Erro ao fazer parse do usuário:', error);
      // Remove dados corrompidos
      localStorage.removeItem('usuario');
      localStorage.removeItem('user');
      return null;
    }
  }
  console.log('Nenhum usuário encontrado no localStorage');
  return null;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const isAuth = !!token;
  console.log('Status de autenticação:', isAuth, 'Token:', token);
  return isAuth;
};

export const getAuthToken = () => {
  const token = localStorage.getItem('token');
  console.log('Token recuperado do localStorage:', token);
  return token;
};

export const getUserInfo = async () => {
  try {
    console.log('Solicitando informações do usuário');
    const response = await api.get('/auth/verificar-sessao');
    console.log('Informações do usuário recebidas:', response.data);
    return response.data;
  } catch (error) {
    // ✅ CORREÇÃO: Removido o 'return'
    handleApiError(error, 'getUserInfo');
  }
};

export const loginService = login;
export const logoutService = logout;